var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pano",class:{
    loading: _vm.Loading,
  }},[_c('img',{staticClass:"pano__loader",attrs:{"src":require("@/assets/Images/Global/Loader.svg"),"alt":""}}),_c('iframe',{staticClass:"pano__content",attrs:{"src":"https://3drender.es/Trabajos/doccia/","frameborder":"0"},on:{"load":function($event){_vm.Loading = false}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }